import axios from "axios";

// const
const APPLICATION_MANAGEMENT_ENTERPRISE_UPDATE_DATA = "applicationManagementEnterprise/APPLICATION_MANAGEMENT_ENTERPRISE_UPDATE_DATA";
const APPLICATION_MANAGEMENT_ENTERPRISE_STORE_APPLICATIONS = "applicationManagementEnterprise/APPLICATION_MANAGEMENT_ENTERPRISE_STORE_APPLICATIONS";
const APPLICATION_MANAGEMENT_ENTERPRISE_STORE_VERSIONS = "applicationManagementEnterprise/APPLICATION_MANAGEMENT_ENTERPRISE_STORE_VERSIONS";
const APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_MODAL = "applicationManagementEnterprise/APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_MODAL";
const APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_LOADING = "applicationManagementEnterprise/APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_LOADING";

const APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_SUCCESS_TITLE = "scenes_Application_ApplicationManagementEnterprise_modal_success_title";
const APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_FAIL_TITLE = "scenes_Application_ApplicationManagementEnterprise_modal_fail_title";
const APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_STATUS_SUCCESS_CONTENT = "scenes_Application_ApplicationManagementEnterprise_modal_statusSuccess_content";
const APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_STATUS_FAIL_CONTENT = "scenes_Application_ApplicationManagementEnterprise_modal_statusFail_content";
const APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_OK_LABEL = "scenes_Application_ApplicationManagementEnterprise_modal_OK_label";
const APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_CANCEL_LABEL = "scenes_Application_ApplicationManagementEnterprise_modal_cancel_label";

// reducer
export const applicationManagementEnterprise = (state = {

  loading: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  name: "",
  applications: [],
  versions: [],
  showApplications: [],
  selectedKey: "",
  applicationStatusCode: "",
}, action) => {
  switch (action.type) {
    case APPLICATION_MANAGEMENT_ENTERPRISE_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_MANAGEMENT_ENTERPRISE_STORE_APPLICATIONS:
      return {
        ...state,
        applications: action.data,
        showApplications: action.data,
        selectedKey: "",
        applicationStatusCode: ""
      };
    case APPLICATION_MANAGEMENT_ENTERPRISE_STORE_VERSIONS:
      return {
        ...state,
        versions: action.data,
      };
    case APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateApplicationManagementEnterpriseData = (data) => {
  return {
    type: APPLICATION_MANAGEMENT_ENTERPRISE_UPDATE_DATA,
    data: data
  }
};


/**
 * get all app by user id
 */
export const getApplications = (companyId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-application/getApplicationByCompanyId/${companyId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplications(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all app applications
 */
export const storeApplications = (applications) => {
  return {
    type: APPLICATION_MANAGEMENT_ENTERPRISE_STORE_APPLICATIONS,
    data: applications
  }
};

/**
 * get all version by user id
 */
export const getVersions = (companyId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-application/getVersionByCompanyId/${companyId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeVersions(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all version
 */
export const storeVersions = (versions) => {
  return {
    type: APPLICATION_MANAGEMENT_ENTERPRISE_STORE_VERSIONS,
    data: versions
  }
};

/**
 * filter application
 */
export const filterApplication = (data) => (dispatch) => {
  let showApplications = data.applications.filter(application => {
    return application.name.indexOf(data.name) > -1
  });
  dispatch(updateApplicationManagementEnterpriseData({
    name: "showApplications",
    value: showApplications
  }));
  dispatch(updateApplicationManagementEnterpriseData({
    name: "selectedKey",
    value: ""
  }));
  dispatch(updateApplicationManagementEnterpriseData({
    name: "applicationStatusCode",
    value: ""
  }));
};

/**
 * update application status
 */
export const updateApplicationStatus = (data) => (dispatch) => {
  axios({
    method: "PUT",
    url: `/api-application/updateApplicationStatus`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      id: data.id,
      status: {code: data.code}
    }
  }).then(
    response => {
      if (response.status === 200) {
        dispatch(getApplications(data.user));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_SUCCESS_TITLE,
          modalContent: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_STATUS_SUCCESS_CONTENT,
          modalOk: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_OK_LABEL,
          modalCancel: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        if (data.status === "3" || data.status === "5"||data.status === "2") {
          dispatch(sendMessage({
            actorId: data.releaseUserId,
            applicationId: data.applicationId,
            applicationName: data.applicationName,
            statusName: data.status === "3" ? "上线" : "下线",
            title:"应用"
          }));
        }
        console.log("success update application status");
      } else {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_FAIL_TITLE,
          modalContent: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_STATUS_FAIL_CONTENT,
          modalOk: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_OK_LABEL,
          modalCancel: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        console.log("fail to update application status");
      }
    }
  );
};

/**
 * update application status
 */
export const updateVersionStatus = (data) => (dispatch) => {
  axios({
    method: "PUT",
    url: `/api-application/updateVersionStatus`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      id: data.id,
      status: {code: data.code}
    }
  }).then(
    response => {
      if (response.status === 200) {
        dispatch(getVersions(data.user));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_SUCCESS_TITLE,
          modalContent: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_STATUS_SUCCESS_CONTENT,
          modalOk: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_OK_LABEL,
          modalCancel: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        if (data.status === "3" || data.status === "5"||data.status === "2") {
          dispatch(sendMessage({
            actorId: data.releaseUserId,
            applicationId: data.applicationId,
            applicationName: data.applicationName,
            version: data.version,
            statusName: data.status === "3" ? "上线" : "下线",
            title:"版本"
          }));
        }
        console.log("success update application status");
      } else {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_FAIL_TITLE,
          modalContent: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_STATUS_FAIL_CONTENT,
          modalOk: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_OK_LABEL,
          modalCancel: APPLICATION_MANAGEMENT_ENTERPRISE_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        console.log("fail to update application status");
      }
    }
  );
};

/**
 * send message
 */
export const sendMessage = (data) => (dispatch) => {
  axios({
    method: "GET",
    url: `/api-application/getSubscribeUserIdsByApplicationId/${data.applicationId}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      if (response.status === 200 && response.data) {
        axios({
          method: "post",
          url: "/api-user/notificationObjects",
          contentType: "application/json",
          withCredentials: true,
          data: {
            "actorId": data.actorId,
            "notifierIds": response.data,
            "title": `${data.title}${data.statusName}通知`,
            "description": data.version?`您所订阅的应用【${data.applicationName}】中版本【${data.version}】${data.statusName}！`:`您所订阅的应用【${data.applicationName}】${data.statusName}！`,
            "type": "用户消息",
            "selfType": "02",
            "action": `${data.title}状态变更`,
            "ways": "sendEmail"
          }
        }).then(
          response => {
            if (response.status === 200) {
              console.info("success to send a message");
            } else {
              console.error("fail to send a message")
            }
          },
          error => {
            console.error("fail to send a message", error)
          }
        );
      }
    }
  );
};


/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_MANAGEMENT_ENTERPRISE_TOGGLE_LOADING,
    data: show
  }
};
